import React, { FunctionComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { EditExpertsContainer } from '../../containers';

const ExamExpertsPage: FunctionComponent<Props> = ({ match }) => (
    <EditExpertsContainer
      examId={match.params.id}
      qualificationId={match.params.qualifId}
    />
);

export default withRouter(ExamExpertsPage);

interface OwnProps {
    id: string;
    qualifId: string;
}

type Props = RouteComponentProps<OwnProps>;
